/*what-is-turborepo*/
/*the-monorepo-problem*/
/*the-monorepo-solution*/
/*how-to-use-these-docs*/
/*join-the-community*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "简介",
  "description": "欢迎阅读 Turborepo 文档！"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "欢迎阅读 Turborepo 文档！"
  }, {
    "heading": "",
    "content": "¥Welcome to the Turborepo documentation!"
  }, {
    "heading": "什么是-turborepo-what-is-turborepo",
    "content": "¥What is Turborepo?"
  }, {
    "heading": "什么是-turborepo-what-is-turborepo",
    "content": "Turborepo 是一个适用于 JavaScript 和 TypeScript 代码库的高性能构建系统。它旨在扩展单一存储库，同时也能加快 单包工作区 中的工作流程。"
  }, {
    "heading": "什么是-turborepo-what-is-turborepo",
    "content": "¥Turborepo is a high-performance build system for JavaScript and TypeScript codebases. It is designed for scaling monorepos and also makes workflows in single-package workspaces faster, too."
  }, {
    "heading": "什么是-turborepo-what-is-turborepo",
    "content": "从个人开发者到全球最大的企业工程组织，Turborepo 通过一种轻量级方法优化你需要在存储库中运行的任务，节省了数年的工程时间和数百万美元的计算成本。"
  }, {
    "heading": "什么是-turborepo-what-is-turborepo",
    "content": "¥From individual developers to the largest enterprise engineering organizations in the world, Turborepo is saving years of engineering time and millions of dollars in compute costs through a lightweight approach to optimizing the tasks you need to run in your repository."
  }, {
    "heading": "monorepo-问题-the-monorepo-problem",
    "content": "¥The monorepo problem"
  }, {
    "heading": "monorepo-问题-the-monorepo-problem",
    "content": "Monorepos 有很多优势 - 但它们难以扩展。每个工作区都有自己的测试套件、自己的 linting 和自己的构建过程。单个 monorepo 可能有数千个任务要执行。"
  }, {
    "heading": "monorepo-问题-the-monorepo-problem",
    "content": "¥Monorepos have many advantages - but they struggle to scale. Each workspace has its own test suite, its own linting, and its own build process. A single monorepo might have thousands of tasks to execute."
  }, {
    "heading": "monorepo-问题-the-monorepo-problem",
    "content": "这些速度下降会极大地影响你的团队构建软件的方式，尤其是在大规模构建时。反馈循环需要快速，以便开发者能够快速交付高质量的代码。"
  }, {
    "heading": "monorepo-问题-the-monorepo-problem",
    "content": "¥These slowdowns can dramatically affect the way your teams build software, especially at scale. Feedback loops need to be fast so developers can deliver high-quality code quickly."
  }, {
    "heading": "monorepo-解决方案-the-monorepo-solution",
    "content": "¥The monorepo solution"
  }, {
    "heading": "monorepo-解决方案-the-monorepo-solution",
    "content": "Turborepo 解决了你的 monorepo 的扩展问题。远程缓存 存储所有任务的结果，这意味着你的 CI 无需重复执行相同的工作。"
  }, {
    "heading": "monorepo-解决方案-the-monorepo-solution",
    "content": "¥Turborepo solves your monorepo's scaling problem. Remote Cache stores the result of all your tasks, meaning that your CI never needs to do the same work twice."
  }, {
    "heading": "monorepo-解决方案-the-monorepo-solution",
    "content": "此外，在 monorepo 中，任务调度可能很困难。你可能需要先构建，然后测试，最后进行 lint……"
  }, {
    "heading": "monorepo-解决方案-the-monorepo-solution",
    "content": "¥Additionally, task scheduling can be difficult in a monorepo. You may need to build, then test, then lint..."
  }, {
    "heading": "monorepo-解决方案-the-monorepo-solution",
    "content": "Turborepo 会以最大速度调度你的任务，并在所有可用核心上并行执行工作。"
  }, {
    "heading": "monorepo-解决方案-the-monorepo-solution",
    "content": "¥Turborepo schedules your tasks for maximum speed, parallelizing work across all available cores."
  }, {
    "heading": "monorepo-解决方案-the-monorepo-solution",
    "content": "Turborepo 可以逐步采用，你只需几分钟即可将其添加到任何存储库。它使用你已编写的 package.json 脚本、你已声明的依赖以及单个 turbo.json 文件。你可以将它与任何软件包管理器一起使用，例如 npm、yarn 或 pnpm，因为 Turborepo 依赖于 npm 生态系统的约定。"
  }, {
    "heading": "monorepo-解决方案-the-monorepo-solution",
    "content": "¥Turborepo can be adopted incrementally and you can add it to any repository in just a few minutes. It uses the package.json scripts you've already written, the dependencies you've already declared, and a single turbo.json file. You can use it with any package manager, like npm, yarn or pnpm since Turborepo leans on the conventions of the npm ecosystem."
  }, {
    "heading": "如何使用这些文档-how-to-use-these-docs",
    "content": "¥How to use these docs"
  }, {
    "heading": "如何使用这些文档-how-to-use-these-docs",
    "content": "我们将尽量减少专业术语的使用。 - 但在阅读文档时，有一些需要了解的术语很重要。我们创建了 词汇表页面 来帮助你，以防你正在学习这些术语。"
  }, {
    "heading": "如何使用这些文档-how-to-use-these-docs",
    "content": "¥We will do our best to keep jargon to a minimum - but there are some need-to-know words that will be important to understand as you read through the docs. We've created a glossary page to help you out in case you're learning about these terms."
  }, {
    "heading": "加入社区-join-the-community",
    "content": "¥Join the community"
  }, {
    "heading": "加入社区-join-the-community",
    "content": "如果你对 Turborepo 有任何疑问，欢迎随时在 GitHub 讨论、Vercel 社区 和 Twitter 社区提问。"
  }, {
    "heading": "加入社区-join-the-community",
    "content": "¥If you have questions about anything related to Turborepo, you're always welcome to ask the community on GitHub Discussions, Vercel Community, and Twitter."
  }],
  "headings": [{
    "id": "什么是-turborepo-what-is-turborepo",
    "content": "什么是 Turborepo？ /*what-is-turborepo*/"
  }, {
    "id": "monorepo-问题-the-monorepo-problem",
    "content": "monorepo 问题 /*the-monorepo-problem*/"
  }, {
    "id": "monorepo-解决方案-the-monorepo-solution",
    "content": "monorepo 解决方案 /*the-monorepo-solution*/"
  }, {
    "id": "如何使用这些文档-how-to-use-these-docs",
    "content": "如何使用这些文档 /*how-to-use-these-docs*/"
  }, {
    "id": "加入社区-join-the-community",
    "content": "加入社区 /*join-the-community*/"
  }]
};
import __img0 from "./../../public/images/docs/why-turborepo-problem.png";
import __img1 from "./../../public/images/docs/why-turborepo-solution.png";
export const toc = [{
  depth: 2,
  url: "#什么是-turborepo-what-is-turborepo",
  title: _jsx(_Fragment, {
    children: "什么是 Turborepo？ "
  })
}, {
  depth: 2,
  url: "#monorepo-问题-the-monorepo-problem",
  title: _jsx(_Fragment, {
    children: "monorepo 问题 "
  })
}, {
  depth: 2,
  url: "#monorepo-解决方案-the-monorepo-solution",
  title: _jsx(_Fragment, {
    children: "monorepo 解决方案 "
  })
}, {
  depth: 2,
  url: "#如何使用这些文档-how-to-use-these-docs",
  title: _jsx(_Fragment, {
    children: "如何使用这些文档 "
  })
}, {
  depth: 2,
  url: "#加入社区-join-the-community",
  title: _jsx(_Fragment, {
    children: "加入社区 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    hr: "hr",
    img: "img",
    p: "p",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "欢迎阅读 Turborepo 文档！"
    }), "\n", _jsx(_components.p, {
      children: "¥Welcome to the Turborepo documentation!"
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h2, {
      id: "什么是-turborepo-what-is-turborepo",
      children: "什么是 Turborepo？ "
    }), "\n", _jsx(_components.p, {
      children: "¥What is Turborepo?"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 是一个适用于 JavaScript 和 TypeScript 代码库的高性能构建系统。它旨在扩展单一存储库，同时也能加快 ", _jsx(_components.a, {
        href: "/docs/guides/single-package-workspaces",
        children: "单包工作区"
      }), " 中的工作流程。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo is a high-performance build system for JavaScript and TypeScript codebases. It is designed for scaling monorepos and also makes workflows in ", _jsx(_components.a, {
        href: "/docs/guides/single-package-workspaces",
        children: "single-package workspaces"
      }), " faster, too."]
    }), "\n", _jsx(_components.p, {
      children: "从个人开发者到全球最大的企业工程组织，Turborepo 通过一种轻量级方法优化你需要在存储库中运行的任务，节省了数年的工程时间和数百万美元的计算成本。"
    }), "\n", _jsx(_components.p, {
      children: "¥From individual developers to the largest enterprise engineering organizations in the world, Turborepo is saving years of engineering time and millions of dollars in compute costs through a lightweight approach to optimizing the tasks you need to run in your repository."
    }), "\n", _jsx(_components.h2, {
      id: "monorepo-问题-the-monorepo-problem",
      children: "monorepo 问题 "
    }), "\n", _jsx(_components.p, {
      children: "¥The monorepo problem"
    }), "\n", _jsx(_components.p, {
      children: "Monorepos 有很多优势 - 但它们难以扩展。每个工作区都有自己的测试套件、自己的 linting 和自己的构建过程。单个 monorepo 可能有数千个任务要执行。"
    }), "\n", _jsxs(_components.p, {
      children: ["¥Monorepos have many advantages - but ", _jsx(_components.strong, {
        children: "they struggle to scale"
      }), ". Each workspace has its own test suite, its own linting, and its own build process. A single monorepo might have ", _jsx(_components.strong, {
        children: "thousands of tasks to execute"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "A representation of a typical monorepo. The first application took 110 seconds to complete its tasks. The second application took 140 seconds to complete its tasks. The shared package between them took 90 seconds to complete its tasks.",
        placeholder: "blur",
        src: __img0
      })
    }), "\n", _jsx(_components.p, {
      children: "这些速度下降会极大地影响你的团队构建软件的方式，尤其是在大规模构建时。反馈循环需要快速，以便开发者能够快速交付高质量的代码。"
    }), "\n", _jsx(_components.p, {
      children: "¥These slowdowns can dramatically affect the way your teams build software, especially at scale. Feedback loops need to be fast so developers can deliver high-quality code quickly."
    }), "\n", _jsx(_components.h2, {
      id: "monorepo-解决方案-the-monorepo-solution",
      children: "monorepo 解决方案 "
    }), "\n", _jsx(_components.p, {
      children: "¥The monorepo solution"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "The monorepo from before using Turborepo, showing how it can hit cache to complete tasks for all three packages in 80 milliseconds.",
        placeholder: "blur",
        src: __img1
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 解决了你的 monorepo 的扩展问题。", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "远程缓存"
      }), " 存储所有任务的结果，这意味着你的 CI 无需重复执行相同的工作。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.strong, {
        children: "Turborepo solves your monorepo's scaling problem"
      }), ". ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Cache"
      }), " stores the result of all your tasks, meaning that ", _jsx(_components.strong, {
        children: "your CI never needs to do the same work twice"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "此外，在 monorepo 中，任务调度可能很困难。你可能需要先构建，然后测试，最后进行 lint……"
    }), "\n", _jsxs(_components.p, {
      children: ["¥Additionally, task scheduling can be difficult in a monorepo. You may need to build, ", _jsx(_components.em, {
        children: "then"
      }), " test, ", _jsx(_components.em, {
        children: "then"
      }), " lint..."]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 会以最大速度调度你的任务，并在所有可用核心上并行执行工作。"
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo ", _jsx(_components.strong, {
        children: "schedules your tasks for maximum speed"
      }), ", parallelizing work across all available cores."]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 可以逐步采用，你只需几分钟即可将其添加到任何存储库。它使用你已编写的 ", _jsx(_components.code, {
        children: "package.json"
      }), " 脚本、你已声明的依赖以及单个 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 文件。你可以将它与任何软件包管理器一起使用，例如 ", _jsx(_components.code, {
        children: "npm"
      }), "、", _jsx(_components.code, {
        children: "yarn"
      }), " 或 ", _jsx(_components.code, {
        children: "pnpm"
      }), "，因为 Turborepo 依赖于 npm 生态系统的约定。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo can be ", _jsx(_components.strong, {
        children: "adopted incrementally"
      }), " and you can ", _jsx(_components.strong, {
        children: "add it to any repository in just a few minutes"
      }), ". It uses the ", _jsx(_components.code, {
        children: "package.json"
      }), " scripts you've already written, the dependencies you've already declared, and a single ", _jsx(_components.code, {
        children: "turbo.json"
      }), " file. You can ", _jsx(_components.strong, {
        children: "use it with any package manager"
      }), ", like ", _jsx(_components.code, {
        children: "npm"
      }), ", ", _jsx(_components.code, {
        children: "yarn"
      }), " or ", _jsx(_components.code, {
        children: "pnpm"
      }), " since Turborepo leans on the conventions of the npm ecosystem."]
    }), "\n", _jsx(_components.h2, {
      id: "如何使用这些文档-how-to-use-these-docs",
      children: "如何使用这些文档 "
    }), "\n", _jsx(_components.p, {
      children: "¥How to use these docs"
    }), "\n", _jsxs(_components.p, {
      children: ["我们将尽量减少专业术语的使用。 - 但在阅读文档时，有一些需要了解的术语很重要。我们创建了 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/vercel-platform/glossary",
        children: "词汇表页面"
      }), " 来帮助你，以防你正在学习这些术语。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥We will do our best to keep jargon to a minimum - but there are some need-to-know words that will be important to understand as you read through the docs. We've created ", _jsx(_components.a, {
        href: "https://vercel.com/docs/vercel-platform/glossary",
        children: "a glossary page"
      }), " to help you out in case you're learning about these terms."]
    }), "\n", _jsx(_components.h2, {
      id: "加入社区-join-the-community",
      children: "加入社区 "
    }), "\n", _jsx(_components.p, {
      children: "¥Join the community"
    }), "\n", _jsxs(_components.p, {
      children: ["如果你对 Turborepo 有任何疑问，欢迎随时在 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/discussions",
        children: "GitHub 讨论"
      }), "、", _jsx(_components.a, {
        href: "https://community.vercel.com/tag/turborepo",
        children: "Vercel 社区"
      }), " 和 ", _jsx(_components.a, {
        href: "https://twitter.com/turborepo",
        children: "Twitter"
      }), " 社区提问。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you have questions about anything related to Turborepo, you're always welcome to ask the community on ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/discussions",
        children: "GitHub Discussions"
      }), ", ", _jsx(_components.a, {
        href: "https://community.vercel.com/tag/turborepo",
        children: "Vercel Community"
      }), ", and ", _jsx(_components.a, {
        href: "https://twitter.com/turborepo",
        children: "Twitter"
      }), "."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
